import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .add-user-modal {
    width: 320px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .add-user-wrapper {
    margin-bottom: 8px;
  }
  .add-user-modal :global(textarea.text-area) {
    resize: none;
    border: solid 1px #676767;
    border-radius: 4px;
    font-size: 16px;
  }
  .add-user-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .add-user-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
